import { createRouter, createWebHashHistory } from 'vue-router'

import  routes  from './routes.js'


const router = createRouter({
  history: createWebHashHistory('/'),
  routes
})
router.beforeEach((to,from)=>{
  if(to.path == '/main/home/classManager' && from.path.includes(to.path)){
    // 若本身就在班级管理路由下 再次点击班级管理不再执行跳转操作
    return false
  }
  return true
})
export default router
